import type {
  StoreDetailsFeatureFlagClient,
  StoreDetailsFeatureFlagReason,
  StoreDetailsFeatureFlagRolloutScope,
  StoreDetailsFeatureFlagRolloutTarget,
  StoreDetailsFeatureFlagRow,
  StoreDetailsFeatureFlagStatusDisplay,
} from '../../../../types/features/storeDetails/featureFlags';

export const STORE_DETAILS_FEATURE_FLAG_CLIENT_LABELS: Record<StoreDetailsFeatureFlagClient, string> = {
  mobile_app: 'Mobile App',
  webapp: 'Web App',
};

export const STORE_DETAILS_FEATURE_FLAG_ROLLOUT_LABELS: Record<StoreDetailsFeatureFlagRolloutTarget, string> = {
  all: 'All',
  stores: 'Selected Stores',
  users: 'Selected Users',
};

export const STORE_DETAILS_FEATURE_FLAG_REASON_LABELS: Record<StoreDetailsFeatureFlagReason, string> = {
  enabled_for_all_stores: 'Enabled for all stores.',
  enabled_for_this_store: 'Enabled for this store.',
  enabled_for_this_user: 'Enabled for this user.',
  globally_disabled: 'Globally disabled.',
  not_selected: 'Not selected for this store.',
};

export const getStoreDetailsFeatureFlagAssignmentDisabled = (row: StoreDetailsFeatureFlagRow): boolean => (
  row.rolloutScope !== 'selected' || row.rolloutTarget !== 'stores'
);

export const getStoreDetailsFeatureFlagGlobalStatus = (
  globalEnabled: boolean,
): StoreDetailsFeatureFlagStatusDisplay => ({
  label: globalEnabled ? 'On' : 'Off',
  tone: globalEnabled ? 'info' : 'danger',
});

export const getStoreDetailsFeatureFlagEffectiveStatus = (
  effectiveEnabled: boolean,
): StoreDetailsFeatureFlagStatusDisplay => ({
  label: effectiveEnabled ? 'Enabled' : 'Disabled',
  tone: effectiveEnabled ? 'success' : 'neutral',
});

export const getStoreDetailsFeatureFlagRolloutStatus = (
  rolloutScope: StoreDetailsFeatureFlagRolloutScope,
  rolloutTarget: StoreDetailsFeatureFlagRolloutTarget,
): StoreDetailsFeatureFlagStatusDisplay => ({
  label: rolloutScope === 'all' ? STORE_DETAILS_FEATURE_FLAG_ROLLOUT_LABELS.all : STORE_DETAILS_FEATURE_FLAG_ROLLOUT_LABELS[rolloutTarget],
  tone: rolloutTarget === 'all' ? 'neutral' : 'warning',
});
